import React from "react";
import TextField from "../../../../Forms/TextField";
import Toggle from "../../../../Forms/Toggle";
import { NavigationalButtons } from "./CreateCourseWizard";
import { useFormikContext, Form, Formik } from "formik";
import useAxios from "axios-hooks";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";
import DropDown from "../../../../Forms/DropDown";
import { Spinner } from "@fluentui/react";

const CompletionStep = ({ courseId, revId, nextOnClick, prevOnClick }) => {
    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `/courses/${courseId}/completion`,
            method: "put",
        },
        { manual: true }
    );

    const [{ data: course, loading }] = useAxios(`courses/${courseId}/${revId || ''}`);

    if (loading)
        return <Spinner className="absolute-center" label="Loading..." />;
    return (
        <div>
            <Formik
                initialValues={{
                    crsPlanTypeId: course.crsPlanTypeID,
                    completionCertPdfId: course.crsPlanTypeId === 1 ? 5 : null,
                    completionHeader: course.completionHeader,
                    completionDescription: course.completionDescription,
                    completionButtonURL: course.completionButtonURL,
                    completionButton: course.completionButton,
                    completionButtonNewTab: course.completionButtonNewTab
                }}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                <Form style={{width:500}}>
                    <CompletionFields />
                    <NavigationalButtons
                        loading={submitting}
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

const CompletionFields = () => {
    const [{ data: planTypes }] = useAxios('courses/plan-types');
    const [{ data: pdfs }] = useAxios('courses/pdfs');

    return (
        <>
            <ChoiceGroup label="Plan Type" name="crsPlanTypeId" options={planTypes && planTypes.map(p => ({ key: p.id, text: p.name }))} required={true} />
            <TextField label="Header" name="completionHeader" description="" />
            <TextField label="Description"  styles={{ fieldGroup: { height: "100px", minHeight:100 }, field: { height: "100px", overflowY: "auto" }, }} multiline rows={8} name="completionDescription" mu description="" />
            <TextField label="Button URL" name="completionButtonURL" description="" />
            <TextField label="Button" name="completionButton" description="" />
            <Toggle label="New Tab" name="completionButtonNewTab" description="" />
        </>
    );
};

export default CompletionStep;
